// Socket.IO owns transport retries. This controller only refreshes credentials
// after authentication rejection and prevents a disposed view from reconnecting.
export default function createSocketLifecycle(socket, getQuery, refreshCredentials) {
    let disposed = false;
    let refreshing = false;
    let rejectedToken = null;

    const updateQuery = () => {
        if (!disposed) socket.io.opts.query = getQuery();
    };
    const wake = () => {
        if (disposed || refreshing || socket.connected || socket.active) return;
        const query = getQuery();
        if (!query.token || query.token === rejectedToken) return;
        socket.io.opts.query = query;
        socket.connect();
    };
    const rejected = () => {
        if (disposed || refreshing) return;
        rejectedToken = socket.io.opts.query?.token;
        socket.disconnect();
        refreshing = true;
        refreshCredentials(() => {
            refreshing = false;
            wake();
        });
    };
    socket.io.on('reconnect_attempt', updateQuery);
    socket.on('connectionRejected', rejected);
    return {
        wake,
        sync() { updateQuery(); wake(); },
        dispose() {
            disposed = true;
            socket.io.off('reconnect_attempt', updateQuery);
            socket.io.reconnection(false);
            socket.removeAllListeners();
            socket.disconnect();
        }
    };
}
